var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "94",
          height: "43",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c(
        "g",
        {
          attrs: {
            "clip-path":
              "url(#deutche-welle-logo_svg__deutche-welle-logo_svg__clip0)",
            fill: "#2C3143",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M35.98 25.77h-2.453l-1.75-4.128-1.72 4.128h-2.453l-2.723-8.526h2.892l1.299 4.421 1.619-4.421h2.2l1.62 4.421 1.299-4.421h2.892L35.98 25.77zm-23.094 5.367c-5.41 0-9.795-4.386-9.795-9.796 0-5.41 4.386-9.795 9.795-9.795 5.41 0 9.796 4.385 9.796 9.795s-4.386 9.796-9.796 9.796zM31.423 8.8a12.464 12.464 0 00-9.322 4.174 12.465 12.465 0 00-9.32-4.174C5.878 8.8.284 14.394.284 21.295c0 6.901 5.594 12.495 12.495 12.495a12.46 12.46 0 009.321-4.174 12.463 12.463 0 009.322 4.174c6.9 0 12.494-5.594 12.494-12.495 0-6.9-5.594-12.495-12.494-12.495z",
            },
          }),
          _c("path", {
            attrs: {
              d: "M13.209 23.415h-2.696v-4.043h2.696c1.953 0 2.65.813 2.65 2.022 0 1.208-.692 2.021-2.65 2.021zm.371-6.86H7.467v9.677h6.113c2.727 0 5.522-1.37 5.522-4.839 0-3.467-2.795-4.838-5.522-4.838z",
            },
          }),
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M65.615 15.051h1.44v5.298H65.86l-.103-.397c-.448.259-.958.479-1.436.479-1.314 0-1.965-.646-1.965-2.224V15.05h1.41v2.929c0 .892.331 1.135 1.02 1.135.218 0 .555-.116.829-.273v-3.79zm-11.453 1.74c0 1.25-.654 2.072-2.09 2.072h-1.04V14.72h1.09c1.444 0 2.04.676 2.04 2.072zm1.604 0c0-2.6-1.466-3.556-3.498-3.556h-2.83v7.114h2.728c1.949 0 3.6-1.057 3.6-3.557zm25.588-.293c-.346-.248-.692-.374-1.092-.374-.737 0-1.146.725-1.168 1.464-.024.767.37 1.547 1.246 1.547.366 0 .673-.07 1.088-.383l.736.883c-.541.492-1.155.788-1.866.788-1.798 0-2.65-1.438-2.623-2.852.026-1.37.878-2.716 2.502-2.716.74 0 1.389.242 1.84.678l-.663.965zm3.02 3.813h-1.422v-7.308h1.421v2.169c.355-.154.894-.317 1.293-.317 1.314 0 2.041.646 2.041 2.224v3.232h-1.429v-3.005c0-.891-.35-1.135-1.04-1.135-.216 0-.592.116-.865.274v3.866zm-25.297-5.454c-1.383 0-2.35 1.15-2.333 2.79.017 1.69.905 2.78 2.549 2.78.727 0 1.492-.317 1.923-.866l-.722-.713s-.465.347-1.093.372c-.759.03-1.22-.416-1.279-1.15h3.135c.332-2.171-.664-3.213-2.18-3.213zm.98 2.249h-1.948c.036-.584.397-1.097.954-1.097.978 0 .99.83.993 1.097zm11.328 1.82s-.276.13-.53.13c-.335 0-.518-.094-.518-.602V16.12h1.28v-1.094h-1.28V13.75H69.19l-.2 1.277h-.95v1.095h.912l-.018 2.67c0 .936.425 1.606 1.488 1.606.551 0 .933-.218 1.36-.522l-.398-.95zm19.685-4.069c-1.383 0-2.35 1.15-2.333 2.79.017 1.69.905 2.78 2.549 2.78.728 0 1.492-.317 1.923-.866l-.722-.713s-.465.347-1.093.372c-.759.03-1.22-.416-1.279-1.15h3.135c.333-2.171-.664-3.213-2.18-3.213zm.98 2.249h-1.948c.035-.584.396-1.097.954-1.097.978 0 .99.83.993 1.097zm-15.706-.647l.426-1.077s-.945-.534-1.978-.518c-1.297.02-2.096.537-2.117 1.512-.013.6.273 1.115.969 1.481.519.274 1.003.434 1.48.612.243.092.412.229.362.458-.041.19-.252.268-.408.29-.64.091-1.412-.153-2.076-.436l-.435 1.022s.95.62 2.174.62c.96 0 2.13-.287 2.218-1.48.056-.755-.273-1.241-1.066-1.569a84.494 84.494 0 00-1.377-.53c-.321-.116-.43-.295-.391-.486.063-.31.529-.302.891-.273.733.058 1.328.374 1.328.374zm-8.334 5.92h-1.422v7.309h1.422V22.38zm-10.463.665h-1.536l-.651 3.08c-.066.336-.18 1.286-.212 1.58a39.83 39.83 0 00-.323-1.58l-.853-3.08h-1.431l-.842 3.08a40.937 40.937 0 00-.323 1.58 33.426 33.426 0 00-.23-1.58l-.634-3.08h-1.557l1.556 6.681H52l.96-3.538c.108-.417.23-1.096.263-1.36.043.264.166.934.274 1.36l.94 3.538h1.554l1.555-6.68zm7.627-.664h-1.42v7.308h1.42V22.38zm-4.801 1.85c-1.384 0-2.35 1.15-2.334 2.79.017 1.69.906 2.778 2.549 2.778.728 0 1.492-.315 1.923-.865l-.721-.712s-.465.346-1.094.371c-.759.03-1.22-.416-1.278-1.149h3.134c.333-2.172-.664-3.213-2.18-3.213zm.978 2.248h-1.947c.036-.584.397-1.097.955-1.097.978 0 .99.83.992 1.097zm10.112-2.248c-1.383 0-2.35 1.15-2.333 2.79.017 1.69.906 2.778 2.548 2.778.728 0 1.493-.315 1.924-.865l-.722-.712s-.465.346-1.093.371c-.76.03-1.22-.416-1.28-1.149h3.135c.334-2.172-.664-3.213-2.179-3.213zm.979 2.248h-1.948c.036-.584.397-1.097.955-1.097.978 0 .99.83.993 1.097z",
            },
          }),
        ]
      ),
      _c("defs", [
        _c(
          "clipPath",
          {
            attrs: {
              id: "deutche-welle-logo_svg__deutche-welle-logo_svg__clip0",
            },
          },
          [
            _c("path", {
              attrs: {
                fill: "#fff",
                transform: "translate(.285 .47)",
                d: "M0 0h93.232v41.65H0z",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }